var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Table } from 'components';
import { loading } from 'elements/Loading';
import { toDate } from '../../../helpers/Format';
import { T } from '../../../helpers/i18n';
var DevicesTable = /** @class */ (function (_super) {
    __extends(DevicesTable, _super);
    function DevicesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            var deviceFiltered = _this.props.devices.filter(function (device) { return device.id === value.id; });
            console.log(deviceFiltered);
        };
        return _this;
    }
    DevicesTable.prototype.componentDidMount = function () {
        console.log('componentDidMount');
    };
    DevicesTable.prototype.render = function () {
        var devices = this.props.devices;
        var mapeados = devices.map(function (value) {
            var temp = __assign({}, value);
            temp.license = value.license.key;
            temp.validoHasta = toDate(new Date(value.license.valid));
            var caducado = (new Date(value.license.valid)).getTime() <= Date.now();
            temp.state = caducado ? T('expiredLicense') : value.blocked_at ? T('block') : value.disabled_at ? T('disabled') : T('activo');
            temp.disabled_at = caducado ? toDate(new Date(value.license.valid)) : value.blocked_at ? toDate(new Date(value.blocked_at)) : value.disabled_at ? toDate(new Date(value.disabled_at)) : '';
            return temp;
        });
        var headers = ['terminalnumero', 'license', 'validoHasta', 'serial', 'model', 'manufacturer', 'brand', 'state', 'disabled_at'];
        if (!(devices.length > 0))
            return React.createElement("div", null,
                React.createElement("p", null, "No hay dispositivos dados de alta"),
                " ");
        return (React.createElement(Table, { items: mapeados, header: headers, onSelectItem: this.handleSelectItem, keyExtractor: function (item) { return String(item.id); }, loading: devices === undefined }));
    };
    DevicesTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.devices.read().then(function (devices) { return ({ devices: devices }); }),
            ];
        }),
        observer
    ], DevicesTable);
    return DevicesTable;
}(Component));
export default DevicesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Devices/container/DevicesTable.tsx
// module id = 1535
// module chunks = 0